var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoSurface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 12V10.6667H4.66669V2.66666H6.08335L3.95835 0.666664L1.83335 2.66666H3.25002V4H0.416687V5.33333H3.25002V12H10.3334V13.3333H8.91669L11.0417 15.3333L13.1667 13.3333H11.75V12H14.5834ZM6.08335 5.33333H10.3334V9.33333H11.75V4H6.08335V5.33333Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSurface);
export default __webpack_public_path__ + "static/media/picto-surface.bd9c584d7cd2a72a2078ac6229f9fcf1.svg";
export { ForwardRef as ReactComponent };